<button class="nav-toggler"
        (click)="toggleNav()">
  <svg width="26" height="21" viewBox="0 0 26 21" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g filter="url(#filter0_d)">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M21 10.5H5H21Z" fill="white"/>
      <path d="M21 10.5H5" stroke="white" stroke-width="2" stroke-linecap="round"/>
    </g>
    <g filter="url(#filter1_d)">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M13 5.5H5H13Z" fill="white"/>
      <path d="M13 5.5H5" stroke="white" stroke-width="2" stroke-linecap="round"/>
    </g>
    <g filter="url(#filter2_d)">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M17 15.5H5H17Z" fill="white"/>
      <path d="M17 15.5H5" stroke="white" stroke-width="2" stroke-linecap="round"/>
    </g>
    <defs>
      <filter id="filter0_d" x="0" y="5.5" width="26" height="10" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
        <feOffset/>
        <feGaussianBlur stdDeviation="2"/>
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"/>
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow"/>
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape"/>
      </filter>
      <filter id="filter1_d" x="0" y="0.5" width="18" height="10" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
        <feOffset/>
        <feGaussianBlur stdDeviation="2"/>
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"/>
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow"/>
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape"/>
      </filter>
      <filter id="filter2_d" x="0" y="10.5" width="22" height="10" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
        <feOffset/>
        <feGaussianBlur stdDeviation="2"/>
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"/>
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow"/>
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape"/>
      </filter>
    </defs>
  </svg>
</button>
<ul class="nav"
    [style.width]="mainWidth"
    [ngClass]="{'visible': navVisibility}">
  <ng-container *ngIf="!authenticated">
    <li class="nav__item">
      <a matRipple
         href="{{ clinicHomeUrl && clinicName ? clinicHomeUrl : 'https://www.viewlabs.co/' }}"
         target="_blank"
         class="d-flex ai-center">
        <svg width="24" height="24" class="mr-1">
          <use [attr.xlink:href]="'#window-i'"/>
        </svg>
        <span>Website</span>
      </a>
    </li>
    <li class="nav__item">
      <a matRipple routerLink="/sign-in" class="d-flex ai-center" (click)="toggleNav()">
        <svg width="24" height="24" class="mr-1">
          <use [attr.xlink:href]="'#lock-i'"/>
        </svg>
        <span>Login</span>
      </a>
    </li>
  </ng-container>

  <ng-container *ngIf="authenticated">
    <li class="nav__item" *ngIf="clinicHomeUrl">
      <a matRipple href="{{ clinicHomeUrl }}" target="_blank" class="d-flex ai-center">
        <svg width="24" height="24" class="mr-1">
          <use [attr.xlink:href]="'#home-i'"/>
        </svg>
        <span>Clinic Home</span>
      </a>
    </li>
    <li class="nav__item">
      <a matRipple (click)="newPatient()" target="_blank" class="d-flex ai-center">
        <svg width="24" height="24" class="mr-1">
          <use [attr.xlink:href]="'#camera-i'"/>
        </svg>
        <span>New Patient</span>
      </a>
    </li>
    <li class="nav__item">
      <a matRipple (click)="openTutorials()" target="_blank" class="d-flex ai-center">
        <svg width="24" height="24" class="mr-1">
          <use [attr.xlink:href]="'#law-i'"/>
        </svg>
        <span>Tutorials</span>
      </a>
    </li>
    <li *ngFor="let link of navList" class="nav__item">
      <a matRipple routerLink="{{ link.href }}" class="d-flex ai-center">
        <svg width="24" height="24" class="mr-1">
          <use [attr.xlink:href]="'#' + link.iconName"/>
        </svg>
        <span>{{ link.title }}</span>
      </a>
    </li>
    <li class="nav__item">
      <a matRipple (click)="logout()" class="d-flex ai-center">
        <svg width="24" height="24" class="mr-1">
          <use [attr.xlink:href]="'#lock-i'"/>
        </svg>
        <span>Logout</span>
      </a>
    </li>
  </ng-container>

  <li class="nav__item mt-a">
    <a matRipple href="{{ legalTermsLink }}" target="_blank" class="d-flex ai-center">
      <svg width="24" height="24" class="mr-1">
        <use [attr.xlink:href]="'#weigher-i'"/>
      </svg>
      <span>Legal</span>
    </a>
  </li>
  <li *ngIf="contactEmail" class="nav__item">
    <a matRipple (click)="mailTo($event)" target="_blank" class="d-flex ai-center">
      <svg width="24" height="24" class="mr-1">
        <use [attr.xlink:href]="'#email-i'"/>
      </svg>
      <span>Email</span>
    </a>
  </li>

  <li *ngIf="showChat" class="nav__item">
    <a matRipple onclick="$crisp.push(['do', 'chat:open'])" (click)="toggleNav()" class="crisp-btn">
      <svg width="66" height="66">
        <use xlink:href="#chat-i"/>
      </svg>
    </a>
  </li>
</ul>
